import { controls } from "../../controls";


const rp961 = {
  label: "Promisary Note ",
  pageLabel: "Promisary Note ",
  starting: true,
  url: "rp961",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [


    ...controls.displayText({ tab: "filter", label: "Region Code", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),



    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),



    ...controls.displayText({ tab: "Modal", label: "Crop Type", width: "col-sm-2" }),
    ...controls.JointType({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "jointtype_code_display", name: "jointtype_display", width: "col-sm-2" }),



    ...controls.displayText({ tab: "Modal", label: "Crop Name", width: "col-sm-2" }),
    ...controls.Title({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "title_display", name: "title_display", width: "col-sm-2" }),


    ...controls.displayText({ tab: "Modal", label: "Season", width: "col-sm-2" }),
    ...controls.SubDivision({ tab: "Modal" }),
    ...controls.showData({ tab: "Modal", data: "sub_division_display", name: "sub_division_display", width: "col-sm-2", displaytype: 'capital' }),


    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-1 " }),



    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Promisary Note",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    clickable: true, //?
    displayColumns: [
      {
        Header: "Sr. No.",
        accessor: "sr_no",
        width: 40,
        rwidth: "*"

      },
      {
        Header: "Branch Code",
        accessor: "domain_code",
        width: 80,
        rwidth: "*"
      },
      {
        Header: "Society Name",
        accessor: "society_name",
        width: 250,
        rwidth: 300
      },
      {
        Header: "Audit class",
        accessor: "audit_class",
        rwidth: "*"
      },
      {
        Header: "Payment Date",
        accessor: "payment_date",
        rwidth: "*"
      },
      {
        Header: "Due Date",
        accessor: "due_date",
        rwidth: "*"
      },
      {
        Header: "Amount",
        accessor: "amount",
        rwidth: "*"
      }
    ]
  }
};

export default rp961;